import { TbStarFilled } from "react-icons/tb";
import "./MostAccessBadge.css";

export function MostAccessBadge() {
	return (
		<span className="most-access-badge">
			<TbStarFilled size={12} />
		</span>
	);
}